import graphql from "babel-plugin-relay/macro";

export const linesOfServiceDropdown = graphql`
    fragment LinesOfServiceFragments_LineOfServiceDropdown on LineOfService @relay(plural:true) {
        id
        name
    }
`